import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import Constants from "../../utils/Constants";

const UsersCloudOptions = ({ cloud, onLeave, onDelete }) => {
  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Leave Cloud"
        onClick={() => {
          console.log("Leave Cloud", cloud);

          onLeave(cloud);
        }}
        icon="mdi mdi-exit-to-app"
        disabled={
          cloud.TenantOwner || cloud.TenantID === Constants.SUP_CLOUD_ID
        }
        tooltip={
          cloud.TenantOwner
            ? "You cannot leave the cloud as the Owner. Pass ownership to another user first."
            : null
        }
      />
      <DropdownOptionWithIcon
        name="Delete Cloud"
        onClick={() => onDelete(cloud)}
        icon="mdi mdi-delete"
        disabled={!cloud.TenantOwner}
      />
    </PopoverDropdownMenu>
  );
};

export default UsersCloudOptions;
